import { render, staticRenderFns } from "./stockReceive.vue?vue&type=template&id=08f3a38e"
import script from "./stockReceive.vue?vue&type=script&lang=js"
export * from "./stockReceive.vue?vue&type=script&lang=js"
import style0 from "./stockReceive.vue?vue&type=style&index=0&id=08f3a38e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports